import { getPanelBrands } from 'common/api/v1/panelsCatalog';

import {
    FETCH_PANEL_BRANDS,
    FETCH_PANEL_BRANDS_FAILURE,
    FETCH_PANEL_BRANDS_SUCCESS,
} from '../actionTypes';
import { createProposalModalActions } from '../reducer';

export default () => (dispatch) => {
    dispatch(createProposalModalActions[FETCH_PANEL_BRANDS]());

    getPanelBrands()
        .then((response) =>
            dispatch(
                createProposalModalActions[FETCH_PANEL_BRANDS_SUCCESS](
                    response?.data?.data,
                ),
            ),
        )
        .catch((error) =>
            dispatch(
                createProposalModalActions[FETCH_PANEL_BRANDS_FAILURE](error),
            ),
        );
};
